import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import FormCodeInput from './FormCodeInput';
import FormLabel from './FormLabel';
import FormInput from './FormInput';
import FormTextArea from './FormTextArea';
import FormFeedback from './FormFeedback';
import FormCheckbox from './FormCheckbox';
import FormRadio from './FormRadio';
import FormSelect from './FormSelect';
import FormIncrementalStepper from './FormIncrementalStepper';
import { Button } from '../buttons';
import { Heart } from '../icons';
import IconChooser from './FormIconChooser';
import visitationIcon from '../../assets/images/dashboard/visitation.svg';
import growthIcon from '../../assets/images/dashboard/growth.svg';
import bathingIcon from '../../assets/images/dashboard/bathing.svg';

function FormShowcase(props) {
  return (
    <form onSubmit={props.handleSubmit} className="form-showcase">
      <FormInput
        labelRenderer={() => <FormLabel>Label</FormLabel>}
        placeholder="Placeholder1"
        name="input1"
      />
      <FormInput
        labelRenderer={() => <FormLabel center>Centered Label</FormLabel>}
        placeholder="Placeholder2"
        name="input2"
      />
      <FormInput
        labelRenderer={() => <FormLabel note="with note">Label</FormLabel>}
        placeholder="Placeholder3"
        name="input3"
      />
      <FormInput
        labelRenderer={() => (
          <FormLabel center note="with note">
            Centered
          </FormLabel>
        )}
        placeholder="Placeholder4"
        name="input4"
      />
      <FormInput
        labelRenderer={() => <FormLabel>With Icon</FormLabel>}
        placeholder="I hope you’re having a wonderful day"
        name="input5"
        icon={Heart}
      />
      <FormInput
        labelRenderer={() => <FormLabel>Disabled Input</FormLabel>}
        disabled
        placeholder="Placeholder5"
        name="disabledInput"
      />
      <FormInput
        labelRenderer={() => <FormLabel>Accepted Input</FormLabel>}
        accept
        placeholder="Placeholder6"
        name="input6"
      />
      <FormFeedback>This is a good thing</FormFeedback>
      <FormInput
        labelRenderer={() => <FormLabel>Rejected Input</FormLabel>}
        reject
        placeholder="Placeholder7"
        name="input7"
      />
      <FormFeedback positive={false}>This is a bad thing</FormFeedback>
      <FormInput
        labelRenderer={() => (
          <FormLabel note="required">Required Input</FormLabel>
        )}
        required
        placeholder="Placeholder8"
        name="input8"
      />
      <FormTextArea
        labelRenderer={() => (
          <FormLabel note="required">Textarea input</FormLabel>
        )}
        placeholder="Textarea 1"
        name="textarea1"
      />
      <FormLabel>Pick options</FormLabel>
      <FormCheckbox name="option1">
        You thought that last label was long but this label is like the Great
        American Novel of form field labels that you think is over but then just
        keeps going
      </FormCheckbox>
      <FormCheckbox name="option2">
        I am a long form label that is clearly too long
      </FormCheckbox>
      <FormCheckbox name="defaultOption">Default Option</FormCheckbox>
      <FormCheckbox name="option4" disabled>
        Disabled Option
      </FormCheckbox>
      <FormLabel>Pick your favourite fruit</FormLabel>
      <FormRadio name="fruit" value="apple">
        Apples
      </FormRadio>
      <FormRadio name="fruit" value="orange">
        Oranges
      </FormRadio>
      <FormRadio name="fruit" value="pineapple" icon={Heart}>
        Pineapples
      </FormRadio>
      <FormRadio name="fruit" value="tomato" disabled>
        Tomato
      </FormRadio>
      <FormLabel>Icon Chooser (small)</FormLabel>
      <IconChooser className="icon-chooser--small">
        <FormRadio
          name="notfruit_small"
          value="visitation"
          imageSrc={visitationIcon}
        >
          Visitation
        </FormRadio>
        <FormRadio name="notfruit_small" value="growth" imageSrc={growthIcon}>
          Growth
        </FormRadio>
        <FormRadio
          name="notfruit_small"
          value="bathing"
          imageSrc={bathingIcon}
          disabled
        >
          Bath Time
        </FormRadio>
      </IconChooser>
      <FormLabel>Icon Chooser (medium - default)</FormLabel>
      <IconChooser>
        <FormRadio name="notfruit" value="visitation" imageSrc={visitationIcon}>
          Visitation
        </FormRadio>
        <FormRadio name="notfruit" value="growth" imageSrc={growthIcon}>
          Growth
        </FormRadio>
        <FormRadio
          name="notfruit"
          value="bathing"
          imageSrc={bathingIcon}
          disabled
        >
          Bath Time
        </FormRadio>
      </IconChooser>
      <FormLabel>Icon Chooser (large)</FormLabel>
      <IconChooser className="icon-chooser--large">
        <FormRadio
          name="notfruit_large"
          value="visitation"
          imageSrc={visitationIcon}
        >
          Visitation
        </FormRadio>
        <FormRadio name="notfruit_large" value="growth" imageSrc={growthIcon}>
          Growth
        </FormRadio>
        <FormRadio
          name="notfruit_large"
          value="bathing"
          imageSrc={bathingIcon}
          disabled
        >
          Bath Time
        </FormRadio>
      </IconChooser>
      <FormLabel>Select a color</FormLabel>
      <FormSelect
        placeholder="Color..."
        required
        options={[
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' }
        ]}
        name="color"
      />
      <FormSelect
        placeholder="Disabled select..."
        options={[
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' }
        ]}
        disabled
        name="disabled-select"
      />
      <FormLabel center>Step through times</FormLabel>
      <FormIncrementalStepper
        name="durationA"
        min={0}
        step={5}
        formatValue={n => (n ? `${n} minutes` : '')}
        placeholder="Enter a time…"
        disabled
      />
      <FormIncrementalStepper
        name="durationB"
        min={0}
        step={5}
        formatValue={n => (n ? `${n} minutes` : '')}
      />
      <FormLabel>Code entry (visible)</FormLabel>
      <FormCodeInput name="codeVisible" fields={5} type="number" />
      <FormLabel>Code entry (obscured)</FormLabel>
      <FormCodeInput name="codeObscured" fields={5} type="password" />
      <FormLabel>Code entry rejected</FormLabel>
      <FormCodeInput name="codeReject" fields={5} type="number" reject />
      <FormLabel>Code entry accepted</FormLabel>
      <FormCodeInput name="codeAccept" fields={5} type="number" accept />
      <FormLabel>Submit, and get values printed to console</FormLabel>
      <Button label="Submit" />
    </form>
  );
}

FormShowcase.propTypes = {
  handleSubmit: PropTypes.func.isRequired
};

export default reduxForm({
  form: 'ExampleForm',
  initialValues: {
    defaultOption: true,
    fruit: 'orange',
    minuteStep: { value: 20, label: '20 minutes' },
    disabledStep: { value: 1, label: 'Option 1' },
    codeReject: '54321',
    codeAccept: '12345'
  }
})(FormShowcase);



// WEBPACK FOOTER //
// ./src/components/form/FormShowcase.js